import { useLayoutEffect, useReducer } from "react";

/**
 * Forces a re-render immediately after mount via `useLayoutEffect`.
 * Required for virtualizers (e.g. @tanstack/react-virtual) so they can
 * measure the real scroll-container dimensions before rendering items.
 */
export function usePostMountFlush(): void {
  const [, remeasure] = useReducer((n: number) => n + 1, 0);
  useLayoutEffect(() => { remeasure(); }, []);
}
